var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticStyle:{"background":"#000"},attrs:{"id":"inspire"}},[_c('v-main',{staticClass:"appBack"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }